import Avatar from '@ui/Avatar';
import Typography from '@ui/Typography';
import React from 'react';
import Link from '@ui/Link';
import AppLink from '../next-ui/Link/Link';
import { cx } from 'cva';
import useUserProfile from '@/hooks/useUserProfile';
import { useBreakpointHooks } from '@/utils/break-points.provider';
import PostType from '@/constants/postType.constants';
import ContributeButton from './ContributionButton';
import { isEmpty, upperCase } from 'lodash-es';

function FundraisingOrgProfileBar(props) {
  const { fundraisingOrg, post = null } = props;
  const isUserPost = PostType.UserPost === post?.sourcePostType;
  const withContribute = !!post && isUserPost;

  const { beneficiary } = post?.sourcePostData || {};

  const isBeneficiaryOrganization =
    beneficiary?.beneficiaryType === 'organization';

  const user = useUserProfile();
  const isLesserThanMediumScreen = useBreakpointHooks((bp) =>
    bp.useSmaller('md'),
  );

  let recordDonationClickPayload = {
    type: 'post',
    postId: post?.id,
    donationClick: {
      userId: user?.id,
      activeCommunityId: user?.activeCommunity?.id,
      location: user?.location,
    },
  };

  const renderContributeButton = () => {
    return (
      <ContributeButton
        variant="outlined"
        fundraisingOrg={fundraisingOrg}
        post={post}
        withIcon
        className="flex-shrink-0 flex-grow-0"
        recordPayload={post?.id ? recordDonationClickPayload : null}
      />
    );
  };

  return (
    <div className="flex w-full flex-col items-start justify-between gap-2 bg-primary-light-1 px-4 py-4 lg:px-6">
      {/* <div className="flex items-center gap-2">
        <Avatar
          src={fundraisingOrg.logoUrl}
          alt={fundraisingOrg.name}
          size="md"
        />
        <div className="flex flex-col">
          <div className="flex items-center">
            <div className="flex items-center gap-2">
              <AppLink
                href={
                  fundraisingOrg?.publicProfile?.slug
                    ? `/${fundraisingOrg.publicProfile.slug}`
                    : null
                }>
                <Typography
                  variant="h5"
                  className={cx(
                    'w-fit font-semibold group-hover:text-text-hyperlink',
                    isLesserThanMediumScreen ? 'text-14' : 'text-20',
                  )}>
                  {fundraisingOrg.name}
                </Typography>
              </AppLink>
            </div>
          </div>
        </div>
      </div> */}
      <div className="flex items-center gap-2">
        <Avatar
          src={isBeneficiaryOrganization ? fundraisingOrg.logoUrl : ''}
          alt={beneficiary?.beneficiaryName}
          size="md"
          profile="company"
        />
        <div>
          <Typography
            variant="body1"
            color="textDisabled"
            className="text-16 font-semibold">
            {'Beneficiary'}
          </Typography>
          {isBeneficiaryOrganization ? (
            <AppLink
              href={
                fundraisingOrg?.publicProfile?.slug
                  ? `/${fundraisingOrg.publicProfile.slug}`
                  : null
              }>
              <Typography
                variant="body1"
                color={
                  fundraisingOrg?.publicProfile?.slug
                    ? 'primary'
                    : 'textSecondary'
                }
                className="text-16 font-semibold group-hover:text-text-hyperlink">
                {fundraisingOrg.name}
              </Typography>
            </AppLink>
          ) : (
            <Typography
              variant="body1"
              color="textSecondary"
              className="text-16 font-semibold">
              {upperCase(beneficiary?.beneficiaryName)}
            </Typography>
          )}

          {!isEmpty(beneficiary?.relationship) && (
            <Typography
              variant="body1"
              color="textDisabled"
              className="text-16">
              {beneficiary.relationship}
            </Typography>
          )}
        </div>
      </div>
      {withContribute && renderContributeButton()}
    </div>
  );
}

export default FundraisingOrgProfileBar;
